import React from "react";
import { Save, UserRound } from "lucide-react";
import { useAuth } from "@core/auth/AuthProvider";
import { TitleToolbar } from "@core/components/TitleToolbar";
import { useAppPreferences } from "@core/preferences/AppPreferencesProvider";

export function ProfileSettingsPage() {
  const { user, isDemoMode } = useAuth();
  const { preferences, setPreference } = useAppPreferences();
  const [preferredName, setPreferredName] = React.useState(preferences.preferredName);
  const [saved, setSaved] = React.useState(false);

  const submit = (event) => {
    event.preventDefault();
    setPreference("preferredName", preferredName.trim());
    setSaved(true);
    window.setTimeout(() => setSaved(false), 1800);
  };

  return (
    <div className="settings-page-stack">
      <TitleToolbar
        density="compact"
        title="Profile information"
        icon={UserRound}
      />
      <section className="settings-card">
        <div className="settings-card-header">
          <span className="settings-list-icon"><UserRound /></span>
          <div><h2>Account identity</h2><p>Signed in user account</p></div>
        </div>
        <div className="profile-identity-row">
          <span className="vp-avatar vp-avatar-large" aria-hidden="true">{user.displayName?.slice(0, 1) || "V"}</span>
          <div><strong>{user.displayName || "Vendor user"}</strong><span>{user.email || "No email available"}</span></div>
          {isDemoMode && <span className="vp-demo-chip">DEMO</span>}
        </div>
        <form className="settings-form" onSubmit={submit}>
          <label>
            <span>Local display name</span>
            <input value={preferredName} onChange={(event) => setPreferredName(event.target.value)} placeholder={user.displayName || "Vendor user"} maxLength={80} />
            <small>Shown in the sidebar and header on this device.</small>
          </label>
          <label>
            <span>Email address</span>
            <input value={user.email || ""} disabled />
            <small>Your primary sign-in email.</small>
          </label>
          <button className="button button-primary" type="submit"><Save /> {saved ? "Saved" : "Save preference"}</button>
        </form>
      </section>
    </div>
  );
}
